// Suchfelder
import debounce from './debounce';

const search = {
    /**
     * Suchergebnis-Felder sollen nicht den unteren Browserrand treffen
     */
    setSearchResultMaxHeight() {
        const searchForm = document.querySelector('.js-searchform');

        if (searchForm) {
            const space = window.innerHeight - searchForm.getBoundingClientRect().top - searchForm.offsetHeight - 50;
            const searchResultOverlay = document.querySelector('.js-search-result-inner');

            searchResultOverlay.style.maxHeight = `${space}px`;
        }
    },

    /**
     * Suchfunktion
     * Wird bei Fokus und Keyup auf einem Suchfeld getriggert
     * @param e
     */
    searchbarAction(e) {
        const searchTerm = e.target.value;
        const searchForm = e.target.parentNode;

        // Suchformular auch nochmal als jQuery-Objekt holen, bis weiter unten das serialize() ersetzt ist
        const $searchForm = $(this).parents('.js-searchform');

        if (searchTerm.length >= 3) {
            search.resetOtherSearches(searchForm);

            // Suchergebnisse ausgeben
            const searchResultInner = searchForm.querySelector('.js-search-result-inner');
            searchResultInner.innerHTML = 'Suche läuft...';
            $.post(window.Chronoto.routes.search, $searchForm.serialize(), (result) => {
                searchResultInner.innerHTML = result;
            });
        } else {
            e.target.parentNode.querySelector('.js-search-result-inner').innerHTML = '';
        }
    },

    /**
     * Suchformular: Suchergebnis-Anzeige offen halten,
     * wenn etwas im Formular eingegeben wurde
     */
    searchFormEvents() {
        const textfields = document.querySelectorAll('.js-search-input');

        if (textfields) {
            textfields.forEach((textfield) => {
                textfield.addEventListener('keyup', (event) => {
                    const form = textfield.parentNode;

                    if (event.target.value !== '') {
                        form.classList.add('search--has-result');
                    } else {
                        form.classList.remove('search--has-result');
                    }
                });
            });

            /**
             * Höhe des Suchergebnis-Feldes begrenzen, damit es nicht aus dem Viewport ragt
             */
            window.onresize = debounce(search.setSearchResultMaxHeight, 250);
            search.setSearchResultMaxHeight();
        }
    },

    /**
     * Zurücksetzen eines einzelnen Suchfeldes und der dazugehörigen Suchergebnisse
     * @param e
     */
    resetSearch(e) {
        e.target.parentNode.querySelector('.js-search-input').value = '';
        e.target.parentNode.querySelector('.js-search-result-inner').innerHTML = '';
        e.target.parentNode.classList.remove('search--has-result');
    },

    /**
     * Setzt alle bis auf das übergebene Suchformular zurück
     * @param activeSearchform
     */
    resetOtherSearches(activeSearchform) {
        // Finde andere Suchergebnisse
        const forms = [...document.querySelectorAll('.js-searchform')];
        const otherForms = forms.filter(element => element !== activeSearchform);

        // Setze andere Suchfelder zurück
        otherForms.forEach((form) => {
            const thisForm = form;

            thisForm.classList.remove('has-result');
            thisForm.querySelector('.js-search-input').value = '';
            thisForm.querySelector('.js-search-result-inner').innerHTML = '';
        });
    },

    init() {
        const inputs = document.querySelectorAll('.js-search-input');
        inputs.forEach((input) => {
            input.addEventListener('keyup', search.searchbarAction);
            input.addEventListener('focus', search.searchbarAction);
        });

        const resetButtons = document.querySelectorAll('.js-search-reset');
        resetButtons.forEach((button) => {
            button.addEventListener('click', search.resetSearch);
        });

        search.searchFormEvents();
    },
};

export default search;
